import React from 'react'
import WatashiHeader from './WatashiHeader'
import WatashiBio from './WatashiBio'

function Watashi() {

  return (
    <div id='watashiDiv'>
      <title>ワタシ</title>
      <WatashiHeader />
      <WatashiBio />
    </div>
  )
}

export default Watashi
